import 'es6-promise/auto'
import Vue from 'vue'
import Vuex from 'vuex'
import Map from './modules/map.js'
import Objects from './modules/objects.js'
import Events from './modules/events.js'
import Reports from './modules/reports.js'
import AppState from './modules/appstate.js'
import Forms from './modules/forms.js'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    objects: Objects,
    events: Events,
    reports: Reports,
    map: Map,
    appState: AppState,
    forms: Forms
  }
})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js